import {apiClient} from '../../../../lib/api-client';
import {NewMaterialOrderProductsResult} from "../types/NewMaterialOrderProductsResult"
import {NewMOProduct} from '../types/NewMOProduct';

export async function apiGetNewMaterialOrderProducts(shipToLocationID: number | undefined, salesChannelID: number,
    roDate: Date | undefined,
    newProducts: NewMOProduct[])
    : Promise<NewMaterialOrderProductsResult> {
    try {
        return await apiClient.post("material-order/new-products",
            {
                shipToLocationID,
                salesChannelID,
                roDate,
                newProducts
            });
    }
    catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            products: [],
            matchingAdhesives: [],
            productMFRSKUs: []
        };
    }
};

